import React from 'react'

const ScoreMedium = ({ height = 30, width = 30, color = 'white' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
            <path d="M5.625 7.5H24.375C25.5 7.5 26.25 8.25 26.25 9.375C26.25 10.5 25.5 11.25 24.375 11.25H5.625C4.5 11.25 3.75 10.5 3.75 9.375C3.75 8.25 4.5 7.5 5.625 7.5ZM5.625 18.75H24.375C25.5 18.75 26.25 19.5 26.25 20.625C26.25 21.75 25.5 22.5 24.375 22.5H5.625C4.5 22.5 3.75 21.75 3.75 20.625C3.75 19.5 4.5 18.75 5.625 18.75Z" fill={color} />
        </svg>
    )
}

export default ScoreMedium